module.exports = __webpack_public_path__ + "static/media/logo-bbmnet.b4f0500b.png";